<template>
    <div class="component-upload-image">
        <!-- :headers="headers" -->
        <el-upload :action="uploadImgUrl" list-type="picture-card" :on-success="handleUploadSuccess" :headers="headers"
            :before-upload="handleBeforeUpload" :limit="limit" :on-error="handleUploadError" :on-exceed="handleExceed"
            name="file" :on-remove="handleRemove" :file-list="fileList" :on-preview="handlePictureCardPreview"
            :class="{ hide: this.fileList.length >= this.limit }" ref="upload">
          <div>
            <i class="el-icon-plus"></i>
          </div>
        </el-upload>
        <div v-if="isShow">
            <span v-for="(item,index) in fileList" :key="index">ossId: {{item.name}}，</span>
        </div>
        <!-- 拖拽排序提示 -->
        <div v-if="fileList.length > 1 && enableSort" class="sort-tip">
            <i class="el-icon-info"></i>
            <span>可拖拽图片进行排序</span>
        </div>
        <el-dialog :visible.sync="dialogVisible" title="预览" width="800" append-to-body>
          <div class="overflowY">
            <img :src="dialogImageUrl" style="display: block; max-width: 100%; margin: 0 auto" />
          </div>
        </el-dialog>
    </div>
</template>

<script>
import { ossApi } from '@/api/api'
import Sortable from 'sortablejs'

export default {
    props: {
        value: [String, Object, Array],
        // 图片数量限制
        limit: {
            type: Number,
            default: 5,
        },
        // 大小限制(MB)
        fileSize: {
            type: Number,
            default: 10,
        },
        // 文件类型, 例如['png', 'jpg', 'jpeg'] 'xlsx'
        fileType: {
            type: Array,
            default: () => ['png', 'jpg', 'jpeg','pdf','webp'],
        },
        // 是否显示提示
        isShowTip: {
            type: Boolean,
            default: true,
        },
        // 是否显示ossId
        isShow: {
            type: Boolean,
            default: false,
        },
        // 是否启用拖拽排序
        enableSort: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            dialogImageUrl: '',
            dialogVisible: false,
            hideUpload: false,
            baseUrl: process.env.VUE_APP_BASE_API,
            uploadImgUrl: process.env.VUE_APP_BASE_API + 'resource/oss/portal/upload', // 上传的图片服务器地址
            headers: {
              Authorization: 'Bearer ' + this.$store.state.user.token,
              Clientid: 'e5cd7e4891bf95d1d19206ce24a7b32e'
            },
            fileList: [],
            sortable: null, // Sortable实例
        };
    },
    watch: {
        value: {
            async handler(val) {
                if (val) {
                    let a = await ossApi(val)
                  let list = a.data
                    // 首先将值转为数组
                    // const list = Array.isArray(val) ? val : this.value.split(',');
                    // 然后将数组转为对象数组
                    this.fileList = list.map(item => {
                        if (typeof item.url === 'string') {
                            if (item.url.indexOf(this.baseUrl) === -1) {
                                item = { name: item.ossId, url: item.url };
                            } else {
                                item = { name: item.ossId, url: item.url };
                            }
                        }
                        return item;
                    });
                    // console.log('fileList监听变化', this.fileList);
                    // 重新初始化拖拽排序
                    this.$nextTick(() => {
                        this.initSortable();
                    });
                } else {
                    this.fileList = [];
                    return [];
                }
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        // 是否显示提示
        showTip() {
            return this.isShowTip && (this.fileType || this.fileSize);
        },
    },
    mounted() {
        // 初始化拖拽排序
        this.$nextTick(() => {
            this.initSortable();
        });
    },
    beforeDestroy() {
        // 销毁Sortable实例
        if (this.sortable) {
            this.sortable.destroy();
        }
    },
    methods: {
        // 初始化拖拽排序
        initSortable() {
            if (!this.enableSort || this.fileList.length <= 1) {
                return;
            }
            
            // 销毁之前的实例
            if (this.sortable) {
                this.sortable.destroy();
            }
            
            // 获取上传列表容器
            const uploadList = this.$refs.upload.$el.querySelector('.el-upload-list--picture-card');
            if (!uploadList) {
                return;
            }
            
            // 创建Sortable实例
            this.sortable = Sortable.create(uploadList, {
                animation: 300, // 动画时间
                ghostClass: 'sortable-ghost', // 拖拽时的样式类
                chosenClass: 'sortable-chosen', // 选中时的样式类
                dragClass: 'sortable-drag', // 拖拽中的样式类
                onEnd: (evt) => {
                    // 拖拽结束后更新文件列表顺序
                    this.handleSortEnd(evt);
                }
            });
        },
        
        // 处理拖拽排序结束
        handleSortEnd(evt) {
            const { oldIndex, newIndex } = evt;
            
            if (oldIndex === newIndex) {
                return;
            }
            
            // 更新fileList数组顺序
            const movedItem = this.fileList.splice(oldIndex, 1)[0];
            this.fileList.splice(newIndex, 0, movedItem);
            
            // 触发值更新
            this.$emit('input', this.listToString(this.fileList));
            this.$emit('sort-change', {
                oldIndex,
                newIndex,
                fileList: [...this.fileList]
            });
            
            // 重新初始化排序（确保DOM更新后）
            this.$nextTick(() => {
                this.initSortable();
            });
        },
        
        // 删除图片
        handleRemove(file, fileList) {
            const findex = this.fileList.map(f => f.name).indexOf(file.name);
            if (findex > -1) {
                this.fileList.splice(findex, 1);
                this.$emit('input', this.listToString(this.fileList));
                
                // 重新初始化排序
                this.$nextTick(() => {
                    this.initSortable();
                });
            }
        },
        // 上传成功回调
        handleUploadSuccess(res) {
            console.log('上传成功??', res);
            if (res.code != '200') {
                this.$message.error('上传失败');
                this.loading.close();
            }
            this.fileList.push({ name: res.data.ossId, url: res.data.url });
            this.$emit('input', this.listToString(this.fileList));
            this.loading.close();
            
            // 重新初始化排序
            this.$nextTick(() => {
                this.initSortable();
            });
        },
        // 上传前loading加载
        handleBeforeUpload(file) {
            let isImg = false;
			// 基础校验
			if (!file.name) {
				this.$message.error('文件未命名')
				return false
			}
			// 正则校验（文件名至少3字符+扩展名）
			const pattern = /^[^\\\/:*?"<>|\s]{3,}\.[a-zA-Z0-9]+$/
			if (!pattern.test(file.name)) {
				this.$message({
					type: 'error',
					message: '文件名需满足：1) 前缀≥3位 2) 不含\\/:*?"<>| 3) 必须有扩展名',
					duration: 5000
				})
				return false
			}
            if (this.fileType.length) {
                let fileExtension = '';
                if (file.name.lastIndexOf('.') > -1) {
                    fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
                }
                isImg = this.fileType.some(type => {
                    if (file.type.indexOf(type) > -1) return true;
                    if (fileExtension && fileExtension.indexOf(type) > -1) return true;
                    return false;
                });
            } else {
                isImg = file.type.indexOf('image') > -1;
            }
            if (!isImg) {
                this.$message.error(`文件格式不正确, 请上传${this.fileType.join('/')}图片格式文件!`);
                return false;
            }
            if (this.fileSize) {
                const isLt = file.size / 1024 / 1024 < this.fileSize;
                if (!isLt) {
                    this.$message.error(`上传头像图片大小不能超过 ${this.fileSize} MB!`);
                    return false;
                }
            }
            this.loading = this.$loading({
                lock: true,
                text: '上传中',
                background: 'rgba(0, 0, 0, 0.7)',
            });
        },
        // 文件个数超出
        handleExceed() {
            this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
        },
        // 上传失败
        handleUploadError() {
            this.$message({
                type: 'error',
                message: '上传失败',
            });
            this.loading.close();
        },
        // 预览
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 对象转成指定字符串分隔
        listToString(list, separator) {
            let strs = '';
            separator = separator || ',';
            console.log("=>(index.vue:171) this.baseUrl", list);
            for (let i in list) {
                strs += list[i].name.replace(this.baseUrl, '') + separator;
            }
            return strs != '' ? strs.substr(0, strs.length - 1) : '';
        },
    },
};
</script>
<style>
	.el-upload--picture-card{
		width: 80px;
		height: 80px;
		line-height: 80px;
	}
	.el-upload-list--picture-card .el-upload-list__item {
	  width: 80px;
	  height: 80px;
	}
	
	/* 拖拽排序样式 */
	.sortable-ghost {
	  opacity: 0.5;
	  background: #c8ebfb;
	}
	
	.sortable-chosen {
	  transform: rotate(5deg);
	}
	
	.sortable-drag {
	  transform: rotate(5deg);
	  opacity: 0.8;
	}
	
	/* 拖拽时的光标样式 */
	.el-upload-list--picture-card .el-upload-list__item:hover {
	  cursor: move;
	}
</style>
<style scoped lang="less">
// .el-upload--picture-card 控制加号部分
::v-deep.hide .el-upload--picture-card {
    display: none;
}

// 去掉动画效果
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
    transition: all 0s;
}

::v-deep .el-list-enter,
.el-list-leave-active {
    opacity: 0;
    transform: translateY(0);
}

// 排序提示样式
.sort-tip {
    font-size: 12px;
	line-height: 16px;
    color: #909399;
    display: flex;
    align-items: center;
    i {
        margin-right: 4px;
    }
}
</style>
